<div class="banner">
  <div class="message-container">
    <mat-icon class="info-icon">info</mat-icon>
    <span class="message">{{ message }}</span>
  </div>
  @if (actionButtonText) {
    <button mat-flat-button color="primary" (click)="onActionClick()" class="action-button">
      {{ actionButtonText }}
    </button>
  }
</div>
